<script>
import { facilityMethods } from '@state/helpers'
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      facilityName: null,
      createFacilityError: null,
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    ...facilityMethods,
    close() {
      this.facilityName = null
      this.show = false
    },
    createFacility() {
      this.facilityAdd({
        facility: {
          name: this.facilityName,
        },
      })
        .then(facility => {
          this.changeFacility({ facilityId: facility.id })
            .then(response => {
              this.facilityName = null
              this.show = false

              this.$router.push({ path: 'settings' })
            })
            .catch(error => {
              this.$swal({
                title: 'Error!',
                text: error.response.data,
                type: 'error',
                confirmButtonText: 'OK',
              })
            })
        })
        .catch(error => {
          this.$swal({
            title: 'Error!',
            text: error.response.data,
            type: 'error',
            confirmButtonText: 'OK',
          })
        })
    },
  },
}
</script>

<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title
        >New Facility</v-card-title
      >

      <v-card-text>
        <v-text-field
          v-model="facilityName"
          label="Facility Name"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark depressed color="secondary" @click="close()">Cancel</v-btn>
        <v-btn dark depressed color="cyan" @click="createFacility">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
